export default "__VITE_ASSET__5620cf2d__"